// extracted by mini-css-extract-plugin
export default {"header":"style_header__Ee7Xe","ticketsList":"style_ticketsList__LsJWH","filtersContainer":"style_filtersContainer__ZRVSc"};